<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15dkYkd/tc-custom/9781423632092.jpg?1728259572344" alt="This image is the cover for the book Little Cowpokes Cookbook"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Little Cowpokes Cookbook
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The author of <i>Hungry Campers</i> teaches kids</b><b>“how to eat like a cowpoke . . . includes snack recipes like cactus kabobs and saddle up s’mores.”—<i>Omaha World-Herald</i> (“Books That Will Get Kids Cooking”)</b><br/>  <br/> Yeehaw! Kids who are ready to live the life of a cowpoke will delight in Zac Williams’ latest children’s cookbook, <i>Little Cowpokes</i>. Range riders will learn to whip up tasty vittles such as Buckin’ Bull Nachos, Get Along Pretzel Doggies, Slow-Cooked Smoky Brisket, Cinnamon Churro Sundae, Pioneer Honey Taffy and more! This here collection of recipes is guaranteed to be just the ticket to delicious cowpoke kiddie cookin’, packed with simple step-by-step recipes and fun photographs as well as style ideas for Wild West parties, chuck wagon cookouts, sagebrush get-togethers, and rodeo roundups.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Zac Williams
      </h2>
      
      <p class="authorDescription body article">Zac Williams is a partner at Williams Visual, a creative communications company. He has been the principal photographer of more than 200 books. He enjoys exploring food and culture through writing and photography. He is also the author of Little Monsters Cookbook and Little Aliens Cookbook. Zac lives with his wife and three children in Pleasant View, Utah. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gibbs Smith
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7ee72d50